export default "__VITE_ASSET__DC1C2FQI__"